module.exports = __webpack_public_path__ + "img/gaming-set.6cd5855d.jpg";